<section id="jornadas">
    
    <div class="container">

        <div class="section-header">
            <h2>{{ data.TITULO }}</h2>
            <h4 *ngFor="let paragrafo of data.PARAGRAFOS">{{ paragrafo.TEXTO }}</h4>
        </div>

        <div class="row d-flex justify-content-between align-items-center">
            <div *ngFor="let dado of data.DADOS" class="col-lg-4 mb-2">
                <img class="img-fluid" src="{{dado.IMAGEM.URL}}" alt="{{dado.IMAGEM.DESCRICAO}}">
                <p class="text-center">{{ dado.TEXTO }}</p>
            </div>
        </div>

    </div>

</section>